import React from "react";
import Loadable from "react-loadable";
import EmptyLoading from "../../components/empty-loading";

const SettingsLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "page-settings" */
      /* webpackMode: "lazy" */
      "./../settings"
    ),
  loading: EmptyLoading,
});

export default SettingsLoadable;
